var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"technical-support left"},[_c('div',[_vm._v("技术支持：湖南华菱电子商务有限公司")])])
}]

export { render, staticRenderFns }